import { TEXT } from '../../items';
import { templateTextFieldsEnabled } from '../../utils/templateTextFields';
import { ItemOfType } from './types';

type Email = ItemOfType<'Email'>;

/** In an email's body, the name learners are greeted with: the email's title. */
export const USER_TOKEN = '[user]';

/**
 * An email's body, and in the editor the name its [user] token stands for.
 * Learners read the body with the token replaced by the email's title. The
 * editor edits the body as written, token included, so saving the body never
 * turns the token into the name. For a company with the template text fields,
 * it also edits the name on its own line, and offers an empty body as a cue.
 */
export const emailBodyItems = (email: Email, contentEditable: boolean) => [
  {
    type: TEXT as typeof TEXT,
    id: `${email.id}_body`,
    items: [],
    values: contentEditable
      ? {
          ...(templateTextFieldsEnabled() ? { emptyHint: 'Add message' } : {}),
          value: email.body || '',
          variant: 'text'
        }
      : {
          value: email.body?.replace(
            USER_TOKEN,
            email.title ? email.title : ''
          ),
          variant: 'text'
        }
  },
  ...(contentEditable &&
  templateTextFieldsEnabled() &&
  email.body?.includes(USER_TOKEN)
    ? [
        {
          type: TEXT as typeof TEXT,
          id: `${email.id}_title`,
          items: [],
          values: {
            emptyHint: 'Add name',
            value: email.title || '',
            variant: 'text',
            allowNewLines: false,
            textAlignment: false,
            disableRewrite: true
          }
        }
      ]
    : [])
];
